import { generatePath } from 'react-router-dom';
import {
  Currency,
  formatBalance,
  formatDate,
  ButtonSize,
  IconDownload,
  ButtonSecondary,
} from '@ui/src';
import ROUTES from '../../../../routes';
import { OrganizationType, StatementListItemProps } from '../../types';

import cn from '../styles.module.css';

const formatStatementsList = (
  list: StatementListItemProps[],
  customerType: OrganizationType,
  onDownloadStatement: (id: string) => void,
  accountsPage?: boolean,
  search?: string,
  customerId?: string,
  currencies?: Currency[],
  downloadIsLoading?: boolean,
  downloadedId?: string,
  exportAllowed?: boolean,
): StatementListItemProps[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let link = ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_TRANSACTIONS_GL;

    if (accountsPage) {
      link = ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_TRANSACTION_GL;
    }

    if (customerType === OrganizationType.CORPORATE) {
      link = ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_TRANSACTIONS_GL;

      if (accountsPage) {
        link = ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_TRANSACTION_GL;
      }
    }

    result.url = generatePath(`${link}${search || ''}`, {
      transactionId: result.generalLedgerTransactionId as string,
      customerId: customerId as string,
    });

    const render: Record<string, React.JSX.Element> = {
      transferDate: <div>{formatDate(result.transferDate || '', true)}</div>,
      counterpartyFullName: (
        <div>
          {(!result.counterpartyFullName?.includes('null')
            ? result.counterpartyFullName
            : '-') || ''}
        </div>
      ),
      counterpartyAccountNumber: (
        <div>{result.counterpartyAccountNumber || '-'}</div>
      ),
      debitSum: (
        <div>
          {result.debitSum
            ? formatBalance(
                result.debitSum,
                currencies?.find(
                  (currency) => currency.id === result.currencyId,
                ),
              )
            : '0.00'}
        </div>
      ),
      creditSum: (
        <div className={cn.balance}>
          <span>
            {result.creditSum
              ? formatBalance(
                  result.creditSum,
                  currencies?.find(
                    (currency) => currency.id === result.currencyId,
                  ),
                )
              : '0.00'}
          </span>

          {exportAllowed && result.generalLedgerTransactionId && (
            <ButtonSecondary
              size={ButtonSize.SMALL}
              className={`button-white ${cn.downloadPdfButton}`}
              text={
                downloadIsLoading && downloadedId === result.id
                  ? 'Loading...'
                  : 'PDF'
              }
              icon={<IconDownload />}
              disabled={Boolean(
                downloadIsLoading && downloadedId === result.id,
              )}
              onClick={() => onDownloadStatement(result.id)}
            />
          )}
        </div>
      ),
      currencyId: <div>{result.currency?.name}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatStatementsList;
